import React from 'react';
import { init } from 'goaffpro-client';
import { useNavigate } from 'react-router-dom';
import GeneralLogin from './GeneralLogin';

init(process.env.REACT_APP_GOAFFPRO_PUBLIC_KEY!);

const GeneralLoginContainer = () => {
  const navigateTo = useNavigate();
  return (
    <>
      <GeneralLogin />
    </>
  );
};

export default GeneralLoginContainer;
